<template>
  <header class="header">
      <nav class="header-nav">
        <img src="../../assets/icon/main/logo.png"
             draggable="false"
             alt=""
             @click="handleHome">
        <img class="header-nav-title"
             src="../../assets/icon/main/logo-title.png"
             draggable="false"
             alt=""
             @click="handleHome">
        <router-link v-if="$route.path !== '/'" style="margin-left: 40px;" to="/">首页</router-link>
        <span class="header-nav-vip"
              @click="handleVip">
          了解会员
        </span>
        <img v-if="isLogin"
             :src="avatar || require('../../assets/icon/main/avatar-default.png')"
             class="header-nav-avatar"
             alt=""
             @click="handleVip">
        <img v-else
             src="../../assets/icon/main/avatar-default.png"
             class="header-nav-avatar"
             alt=""
             @click="handleLogin">
      </nav>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Header',
  computed: {
    ...mapGetters([
      'isVip',
      'avatar',
      'isLogin'
    ])
  },
  methods: {
    handleLogin () {
      this.$store.commit('openLoginWindow')
    },
    handleVip () {
      this.$store.commit('openVipWindow')
    },
    handleHome () {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../assets/style/styleVariable";
  @import "../../assets/style/styleMixins";
  .header{
    height: 80px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 0px rgba(146, 146, 146, 0.6);
    &-nav{
      height: 100%;
      max-width: @max_page_width;
      min-width: @min_page_width;
      margin: 0 auto;
      .flex_align_center_mixins;
      &-title{
        margin-left: 12px;
      }
      &-vip{
        margin-left: auto;
        font-size: 14px;
        color: #666666;
        margin-right: 36px;
      }
      &-avatar{
        height: 36px;
        width: 36px;
        border-radius: 50%;
      }
    }
  }
</style>
